module.exports = __webpack_public_path__ + "img/edge_activites_croisiere.0c7795b1.svg";